export let ControlStatus = /*#__PURE__*/function (ControlStatus) {
  ControlStatus["STATUS_WITHOUT_VALIDATION"] = "STATUS_WITHOUT_VALIDATION";
  ControlStatus["STATUS_VALID"] = "STATUS_VALIDE";
  ControlStatus["STATUS_INVALID"] = "STATUS_INVALIDE";
  ControlStatus["STATUS_INACTIVE"] = "STATUS_INACTIVE";
  ControlStatus["STATUS_TO_CHECK"] = "STATUS_TO_CHECK";
  return ControlStatus;
}({});